function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartAdded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 114 114",
    style: {
      enableBackground: "new 0 0 114 114",
      width: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#07A5DB"
    },
    d: "M22.1,50h2.6c1.7,0,3,0.2,3.8,0.6c0.8,0.4,1.5,1.1,2,2.1s0.8,2.1,0.8,3.3c0,0.9-0.1,1.7-0.5,2.5 c-0.3,0.8-0.7,1.4-1.2,1.9s-1.1,0.8-1.7,1s-1.7,0.3-3.2,0.3H22L22.1,50L22.1,50z M24.3,52.1v7.4h1c1,0,1.8-0.1,2.2-0.3 s0.8-0.6,1.1-1.2c0.3-0.5,0.4-1.2,0.4-2c0-1.2-0.4-2.2-1-2.9c-0.6-0.6-1.6-0.9-3-0.9C25.1,52.1,24.3,52.1,24.3,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#07A5DB"
    },
    d: "M39,49.7c1.7,0,3.1,0.6,4.3,1.8s1.8,2.7,1.8,4.4s-0.6,3.2-1.8,4.3C42.1,61.4,40.7,62,39,62 c-1.8,0-3.2-0.6-4.4-1.8s-1.7-2.7-1.7-4.3c0-1.1,0.3-2.2,0.8-3.1s1.3-1.7,2.2-2.2C36.9,50,37.9,49.7,39,49.7z M39,51.9 c-1.1,0-2,0.4-2.7,1.1c-0.7,0.8-1.1,1.7-1.1,2.9c0,1.3,0.5,2.3,1.4,3.1c0.7,0.6,1.5,0.9,2.5,0.9c1.1,0,2-0.4,2.7-1.2 s1.1-1.7,1.1-2.8s-0.4-2.1-1.1-2.8C41,52.3,40.1,51.9,39,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#07A5DB"
    },
    d: "M47.2,50h2.6c1.7,0,3,0.2,3.8,0.6c0.8,0.4,1.5,1.1,2,2.1s0.8,2.1,0.8,3.3c0,0.9-0.2,1.7-0.5,2.5 s-0.7,1.4-1.2,1.9s-1.1,0.8-1.7,1s-1.7,0.3-3.2,0.3h-2.7L47.2,50L47.2,50z M49.4,52.1v7.4h1c1,0,1.8-0.1,2.2-0.3 c0.5-0.2,0.8-0.6,1.1-1.2c0.3-0.5,0.4-1.2,0.4-2c0-1.2-0.3-2.2-1-2.9c-0.6-0.6-1.6-0.9-3-0.9C50.2,52.1,49.4,52.1,49.4,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#07A5DB"
    },
    d: "M62.2,50h2.3L69,61.7h-2.3l-0.9-2.4H61l-1,2.4h-2.3L62.2,50z M63.3,53.1l-1.6,4h3.1L63.3,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#07A5DB"
    },
    d: "M70.6,50h2.1l5,7.7V50H80v11.7h-2.1l-5-7.7v7.7h-2.2L70.6,50L70.6,50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#07A5DB"
    },
    d: "M88.2,49.7c1.7,0,3.1,0.6,4.3,1.8c1.2,1.2,1.8,2.7,1.8,4.4s-0.6,3.2-1.8,4.3 c-1.2,1.2-2.6,1.8-4.3,1.8c-1.8,0-3.2-0.6-4.4-1.8c-1.2-1.2-1.7-2.7-1.7-4.3c0-1.1,0.3-2.2,0.8-3.1s1.3-1.7,2.2-2.2 C86.1,50,87.1,49.7,88.2,49.7z M88.2,51.9c-1.1,0-2,0.4-2.7,1.1c-0.7,0.8-1.1,1.7-1.1,2.9c0,1.3,0.5,2.3,1.4,3.1 c0.7,0.6,1.6,0.9,2.5,0.9c1.1,0,2-0.4,2.7-1.2s1.1-1.7,1.1-2.8s-0.4-2.1-1.1-2.8S89.3,51.9,88.2,51.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    style: {
      fill: "none",
      stroke: "#07A5DB",
      strokeWidth: 9,
      strokeMiterlimit: 10,
      strokeDasharray: 330,
      strokeDashoffset: 330,
      transformOrigin: "center center",
      transform: "rotate(270deg)"
    },
    cx: 57.6,
    cy: 57.1,
    r: 51
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartAdded);
export default __webpack_public_path__ + "static/media/cartAdded.8130813f.svg";
export { ForwardRef as ReactComponent };